import { render, staticRenderFns } from "./base-field-textarea.vue?vue&type=template&id=5248ee22&"
import script from "./base-field-textarea.vue?vue&type=script&lang=js&"
export * from "./base-field-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports